export enum ResponseStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
  }